export const formatAmount = (amountStr: string): string => {
  const amount = parseFloat(amountStr)
  if (Number.isNaN(amount)) return '0'

  return Math.round(amount).toLocaleString('en-IN')
}
